import React from "react";
import { List, ListItem, ListItemText, Typography, Box } from "@mui/material";
import CarePlanActivityItem from "./CarePlanActivityItem";
import { ActivityData } from "../../../utility/interfaces/carePlanInterfaces";
import { useTranslation } from "react-i18next";

interface Props {
  activities: ActivityData[];
}

const CarePlanActivityList: React.FC<Props> = ({ activities }) => {
  const { t } = useTranslation();
  return (
    <List sx={{ mb: 2 }}>
      <ListItem sx={{ p: 0 }}>
        <ListItemText
          primary={
            <Typography
              variant="bodySmall"
              color="common.black"
              letterSpacing="1px"
              fontWeight={600}
              sx={{ textTransform: "uppercase" }}
            >
              {t("carePlan.activity")}
            </Typography>
          }
        />
        <Box display="flex" alignItems="center" gap={2}>
          <Typography
            variant="bodySmall"
            color="common.black"
            letterSpacing="1px"
            fontWeight={600}
            sx={{ textTransform: "uppercase" }}
          >
            {t("carePlan.pointsLabel")}
          </Typography>
        </Box>
      </ListItem>

      {activities.map((activity, index) => (
        <CarePlanActivityItem
          key={activity.activityId}
          activity={activity}
          isLast={index === activities.length - 1}
        />
      ))}
    </List>
  );
};

export default CarePlanActivityList;
